/* eslint-disable */
import React, { useState } from "react";
import { getCommunityUtilityBills } from "../../../actions/appExpandedActions/communities";
import { markUtilityBillAsPaid, uploadUtilityBillReceipt } from "../../../actions"; // NEW: Import actions
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";
import PayEpayUtilityBillModal from "../../ModalComponent/PayEpayUtilityBillModal";

const CommunityUtilityBills = ({
  getCommunityUtilityBills,
  communityUtilityBills,
  period,
  markUtilityBillAsPaid, // NEW
  uploadUtilityBillReceipt, // NEW
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBillId, setSelectedBillId] = useState("");
  const [selectedBillReceiptUrl, setSelectedBillReceiptUrl] = useState(null);
  const [selectedBillStatus, setSelectedBillStatus] = useState(null); // NEW
  const [selectedBillReceiptNote, setSelectedBillReceiptNote] = useState(null); // NEW

  // Handle Pay button click
  const handlePayClick = (billId, status) => {
    console.log("🏢 Communities handlePayClick called with:", billId, status);
    
    // Find the bill to get its receipt URL, status, and receipt note
    const bill = communityUtilityBills?.docs?.find(b => b._id === billId);
    const receiptUrl = bill?.receiptUrl || null;
    const paymentStatus = bill?.epayStatus || status; // Use epayStatus from API
    const receiptNote = bill?.receiptNote || bill?.receiptUrl || null; // Get receipt note
    
    console.log("📋 Community Bill details:", { billId, paymentStatus, receiptUrl, receiptNote });
    
    setSelectedBillId(billId);
    setSelectedBillReceiptUrl(receiptUrl);
    setSelectedBillStatus(paymentStatus);
    setSelectedBillReceiptNote(receiptNote);
    setIsModalOpen(true);
  };

  // Handle modal close
  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedBillId("");
    setSelectedBillReceiptUrl(null);
    setSelectedBillStatus(null);
    setSelectedBillReceiptNote(null);
  };

  // Handle payment confirmation - NEW: Backend-compliant logic
  const handlePaymentConfirm = ({ billId, action, receiptFile, useExistingReceipt, paymentStatus, requiredAction }) => {
    console.log("🏢 Community Payment confirmed:", { billId, action, receiptFile, useExistingReceipt, paymentStatus, requiredAction });
    
    if (action === "mark-as-paid") {
      // Use mark-as-paid endpoint for failed payments
      const payload = {
        billId: billId,
        receiptFile: receiptFile,
        onSuccess: (response) => {
          console.log("✅ Community Mark as paid successful:", response);
          // Refresh the data
          getCommunityUtilityBills({ page: 1 });
        },
        onError: (error) => {
          console.error("❌ Community Mark as paid failed:", error);
        }
      };
      markUtilityBillAsPaid(payload);
      
    } else if (action === "upload-receipt") {
      // Use upload-receipt endpoint for paid payments
      const payload = {
        billId: billId,
        receiptFile: receiptFile,
        useExistingReceipt: useExistingReceipt,
        onSuccess: (response) => {
          console.log("✅ Community Upload receipt successful:", response);
          // Refresh the data
          getCommunityUtilityBills({ page: 1 });
        },
        onError: (error) => {
          console.error("❌ Community Upload receipt failed:", error);
        }
      };
      uploadUtilityBillReceipt(payload);
    }
    
    // Close modal
    handleModalClose();
  };

  // Enhance the data with action handlers
  const enhancedData = {
    ...communityUtilityBills,
    docs: communityUtilityBills?.docs?.map(bill => ({
      ...bill,
      onPayClick: handlePayClick
    }))
  };

  return (
    <>
      <DataTable
        {...tablePresets.communityUtilityBills}
        data={enhancedData}
        fetchData={getCommunityUtilityBills}
        period={period}
      />
      <PayEpayUtilityBillModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        onConfirm={handlePaymentConfirm}
        billId={selectedBillId}
        existingReceiptUrl={selectedBillReceiptUrl}
        paymentStatus={selectedBillStatus}
        existingReceiptNote={selectedBillReceiptNote}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  communityUtilityBills: state.appCommunities.communityUtilityBills,
});

const mapDispatchToProps = (dispatch) => ({
  getCommunityUtilityBills: (payload) => dispatch(getCommunityUtilityBills(payload)),
  markUtilityBillAsPaid: (payload) => dispatch(markUtilityBillAsPaid(payload)),
  uploadUtilityBillReceipt: (payload) => dispatch(uploadUtilityBillReceipt(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CommunityUtilityBills);
